export const Clone = ({
  primaryColor = 'var(--primary-bg-color)',
  secondColor = 'var(--primary-background-text-color',
}) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g
        id="Group_42168"
        data-name="Group 42168"
        transform="translate(-1672 -184)"
      >
        <circle
          id="Ellipse_1247"
          data-name="Ellipse 1247"
          cx="24"
          cy="24"
          r="24"
          transform="translate(1672 184)"
          fill={primaryColor}
        />
        <g id="duplicate" transform="translate(1654.93 166.93)">
          <path
            id="Path_64568"
            data-name="Path 64568"
            d="M123.986,112h-9.071A2.916,2.916,0,0,0,112,114.916v9.071a2.916,2.916,0,0,0,2.916,2.916h9.071a2.916,2.916,0,0,0,2.916-2.916v-9.071A2.916,2.916,0,0,0,123.986,112Zm-1.314,8.1H120.1v2.573a.661.661,0,0,1-.617.665.648.648,0,0,1-.679-.647V120.1H116.23a.661.661,0,0,1-.665-.617.648.648,0,0,1,.647-.679H118.8V116.23a.661.661,0,0,1,.617-.665.648.648,0,0,1,.679.647V118.8h2.592a.648.648,0,0,1,.648.679A.661.661,0,0,1,122.672,120.1Z"
            transform="translate(-76.761 -76.761)"
            fill={secondColor}
          />
          <path
            id="Path_64569"
            data-name="Path 64569"
            d="M46.735,33.944A2.92,2.92,0,0,0,43.986,32H34.916A2.916,2.916,0,0,0,32,34.916v9.071a2.92,2.92,0,0,0,1.944,2.749V37.183a3.239,3.239,0,0,1,3.239-3.239Z"
            fill={secondColor}
          />
        </g>
      </g>
    </svg>
  );
};
